import { Box, SxProps, Theme } from "@mui/material";

export const EMBRACE_LOGO_EXPANDED = "/embrace-logo-expanded.png";
export const EMBRACE_LOGO_COLLAPSED = "/embrace-logo-collapsed.png";

type EmbraceLogoProps = {
  variant?: "expanded" | "collapsed";
  className?: string;
  sx?: SxProps<Theme>;
};

const EmbraceLogo = ({
  variant = "expanded",
  className,
  sx,
}: EmbraceLogoProps) => (
  <Box
    component="img"
    src={
      variant === "expanded"
        ? EMBRACE_LOGO_EXPANDED
        : EMBRACE_LOGO_COLLAPSED
    }
    alt="EMBRACE Research"
    className={className}
    sx={{
      ...(variant === "expanded"
        ? {
            height: { xs: 56, md: 72 },
            width: "auto",
            objectFit: "contain",
          }
        : {
            height: 36,
            width: 36,
            objectFit: "contain",
          }),
      ...sx,
    }}
  />
);

export default EmbraceLogo;
